/*
 * @Author: your name
 * @Date: 2020-11-16 13:49:50
 * @LastEditTime: 2022-05-12 10:56:08
 * @LastEditors: hai.zhang
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\utils\index.js
 */
// import request from './request'
export * from './transformDate'
export * from './url'
export * from './regexp'
export * from './getTagImgUrl'
/**
 * 日期区间选择可开区间时，辅助函数
 * 使用可参考：product/list/search-table.vue
 * @param refer, 参考的时间
 * @param action, 对比的操作，${date}相比${refer}满足此对比操作，则会disable
 * @param type, 参考时间的类型: timestamp/date
 * @param date, 传入的要比对的Date对象
 * @returns {boolean}
 */
export function disabledDate (refer, action, type = 'timestamp', date) {
  if (!refer) {
    return false
  }
  if (type === 'date') {
    refer = new Date(`${refer} 00:00:00`).getTime()
  }
  if (action === '>') {
    return date > refer
  } else if (action === '<') {
    return date < refer
  } else if (action === '>=') {
    return date >= refer
  } else if (action === '<=') {
    return date <= refer
  }
  return false
}

export function __merge (origin = {}, target = {}) {
  for (let p in origin) {
    if (target.hasOwnProperty(p)) {
      origin[p] = target[p]
    }
  }
  return origin
}

export function imgAddHost (text) {
  let imgHost = window.fe.imgHost
  const isLinkRe = /^((http:\/\/)|(https:\/\/)|(\/\/))/
  if (isLinkRe.test(text)) {
    return text
  } else {
    if (text[0] === '/') {
      return imgHost + text
    } else {
      if (imgHost[imgHost.length - 1] === '/') {
        return imgHost + text
      } else {
        return imgHost + '/' + text
      }
    }
  }
}
